var map = {
	"./A1-mexico.png": "ad0d",
	"./A2-czech-republic.png": "2bac",
	"./A3-south-africa.png": "b6aa",
	"./A4-south-korea.png": "70aa",
	"./B5-canada.png": "d39d",
	"./B6-bosnia-herzegovina.png": "f925",
	"./B7-qatar.png": "516b",
	"./B8-switzerland.png": "5d61",
	"./C10-morocco.png": "e45e",
	"./C11-haiti.png": "f39a",
	"./C12-scotland.png": "8d79",
	"./C9-brazil.png": "6cb5",
	"./D13-usa.png": "b680",
	"./D14-turkey.png": "a4a4",
	"./D15-paraguay.png": "d8a7",
	"./D16-australia.png": "4088",
	"./E17-germany.png": "129d",
	"./E18-curacao.png": "2d10",
	"./E19-ivory-coast.png": "32d1",
	"./E20-ecuador.png": "2d4c",
	"./F21-netherlands.png": "dd94",
	"./F22-sweden.png": "fb9b",
	"./F23-japan.png": "aa18",
	"./F24-tunisia.png": "6b05",
	"./G25-belgium.png": "8c62",
	"./G26-egypt.png": "ea2d",
	"./G27-iran.png": "785b",
	"./G28-new-zealand.png": "d68a",
	"./H29-spain.png": "3718",
	"./H30-cape-verde.png": "49da",
	"./H31-saudi-arabia.png": "7594",
	"./H32-uruguay.png": "e235",
	"./I33-france.png": "6707",
	"./I34-iraq.png": "7eac",
	"./I35-senegal.png": "3913",
	"./I36-norway.png": "ed77",
	"./J37-argentina.png": "4fbf",
	"./J38-algeria.png": "0992",
	"./J39-austria.png": "5766",
	"./J40-jordan.png": "121f",
	"./K41-portugal.png": "9348",
	"./K42-dr-congo.png": "d033",
	"./K43-uzbekistan.png": "11c1",
	"./K44-colombia.png": "f3e0",
	"./L45-england.png": "3096",
	"./L46-croatia.png": "7384",
	"./L47-ghana.png": "7f2d",
	"./L48-panama.png": "c872"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9db5";